import { ReactNode } from 'react';
import { BrandingHeader } from '../BrandingHeader';
import { Sidebar } from './Sidebar';
import { useAtajosAccesibilidad } from '@renderer/hooks/useAtajosAccesibilidad';
import { AvisosDomicilio } from '../avisos/AvisosDomicilio';
import { AvisoEntregaTurno } from '../avisos/AvisoEntregaTurno';
import { AvisoImpresora } from '../avisos/AvisoImpresora';
import { AvisoSesionVencida } from '../avisos/AvisoSesionVencida';
import { CerrarAyer } from '../avisos/CerrarAyer';
import { PedidosSinConcluir } from '../avisos/PedidosSinConcluir';
import { CuentasSinCobrar } from '../avisos/CuentasSinCobrar';

interface Props {
  children: ReactNode;
}

export function AppLayout({ children }: Props) {
  // Sprint 40 — atajos Ctrl + / - / 0 montados a nivel layout autenticado.
  useAtajosAccesibilidad();
  return (
    <div className="flex h-full flex-col">
      <BrandingHeader />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        {/*
          Sprint 167 — `pb-32`: los avisos fijos de abajo (impresora, versión nueva) miden ~90 px y
          tapaban lo último de la pantalla sin forma de bajar más. En Configuración → Privacidad el
          botón "Buscar" quedaba debajo del aviso de la impresora: visible a medias e imposible de tocar.
        */}
        <main className="flex-1 overflow-auto bg-slate-50 p-6 pb-32">
          {/* Sprint 160 — La caja de ayer se pregunta al entrar, desde cualquier pantalla. */}
          <CerrarAyer />
          {/* Sprint 164 — Lo que quedó sin concluir de días pasados. Va encima: primero se anota, luego se cuenta. */}
          <PedidosSinConcluir />
          {/* Sprint 168 — Una mesa con la cuenta entregada y sin cobrar, en cualquier pantalla. */}
          <CuentasSinCobrar />
          {children}
        </main>
      </div>
      {/*
        Sprint 103 — Los avisos viven en el layout, no en una pantalla.

        El punto entero es que aparezcan **mientras estás en otra sección**: montarlos dentro del
        tablero sería avisarle a quien ya está mirando. Se ocultan solos cuando sí estás ahí.
      */}
      <AvisosDomicilio />
      {/* Sprint 172 — Cambio de turno de un mesero: globo para caja y dueña. */}
      <AvisoEntregaTurno />
      {/*
        Sprint 156 — Igual que los avisos de domicilio, y por el mismo motivo: que
        la impresora se cayó tiene que verse MIENTRAS cobras, no cuando entres a
        Configuración. Ahí es donde estaba el único aviso el día que la caja
        amaneció sin imprimir, y por eso nadie lo vio.
      */}
      <AvisoImpresora />
      <AvisoSesionVencida />
    </div>
  );
}
